export const EMPTY_DATA = { favorites: [], lists: [] };
export const dataOnly = (data) => ({ favorites: data.favorites || [], lists: data.lists || [] });
export const sameData = (a, b) => JSON.stringify(dataOnly(a)) === JSON.stringify(dataOnly(b));
export function applyChanges(current, base, desired) {
  const changedSet = (curr, old, next) => [...new Set([...curr.filter((id) => !old.includes(id) || next.includes(id)), ...next.filter((id) => !old.includes(id))])];
  const oldLists = new Map(base.lists.map((list) => [list.id, list]));
  const newLists = new Map(desired.lists.map((list) => [list.id, list]));
  const result = new Map(current.lists.filter((list) => !oldLists.has(list.id) || newLists.has(list.id)).map((list) => [list.id, list]));
  newLists.forEach((list, id) => {
    const old = oldLists.get(id), existing = result.get(id);
    if (JSON.stringify(old) === JSON.stringify(list)) return;
    if (!existing) { if (!old) result.set(id, list); return; }
    result.set(id, { id, name: !old || old.name !== list.name ? list.name : existing.name, placeIds: changedSet(existing.placeIds, old?.placeIds || [], list.placeIds) });
  });
  return { favorites: changedSet(current.favorites, base.favorites, desired.favorites), lists: [...result.values()] };
}